import { getNonBmStorEventsJsonData } from "api/dataVisualisation/nonBmStor/nonBmStor";
import InlineButton from "components/components/InlineButton/InlineButton";
import SummaryTile from "components/dataVisualization/dataPageComponents/SummaryTile/SummaryTile";
import {
  Header,
  SummaryTable,
  ValueCell,
} from "components/dataVisualization/dataPageComponents/SummaryTile/commonStyle";
import { useChartFocussedDateContext } from "contexts/ChartFocussedDateContext";
import { NonBmStorModel } from "models/nonBmStor/nonBmStorModel";
import React, { useEffect, useState } from "react";
import { DateFormat, formatDateTimeString } from "utils/dateHelpers";

const NUMBER_OF_EVENTS = 3;

const ShortTermOperatingReservesSummaryTile: React.FC = () => {
  const [summaryTileData, setSummaryTileData] = useState<NonBmStorModel[]>();

  useEffect(() => {
    getNonBmStorEventsJsonData(NUMBER_OF_EVENTS)
      .then((response) => {
        if (response && response.data.length === 0) {
          return;
        }

        setSummaryTileData(response.data);
      })
      // TODO 36876: Add error handling for failed calls to the API and empty data returned
      // eslint-disable-next-line no-console
      .catch(console.log);
  }, []);

  const { setFocussedDate: setFocus } = useChartFocussedDateContext();

  return (
    <SummaryTile>
      <SummaryTable $tableLayout="fixed">
        <thead>
          <tr>
            <Header colSpan={4}>Latest non-zero instances (UTC)</Header>
          </tr>
        </thead>
        <tbody>
          {summaryTileData ? (
            summaryTileData.map((event, index) => (
              <tr key={event.startTime.toString()}>
                <ValueCell
                  colSpan={2}
                  className="left-align"
                  data-test-id={`non-zero-event-date-${index}`}
                >
                  {formatDateTimeString(
                    new Date(event.startTime),
                    DateFormat.DateOnly
                  )}
                </ValueCell>
                <td colSpan={1} data-test-id={`non-zero-event-time-${index}`}>
                  {formatDateTimeString(
                    new Date(event.startTime),
                    DateFormat.TimeOnly
                  )}
                </td>
                <td
                  colSpan={1}
                  className="right-align"
                  data-test-id={`non-zero-event-view-${index}`}
                >
                  <InlineButton
                    onClick={(): void => setFocus(new Date(event.startTime))}
                    buttonText="View"
                  />
                </td>
              </tr>
            ))
          ) : (
            <>
              <tr>
                <td data-test-id="non-zero-event-placeholder-0">—</td>
              </tr>
              <tr>
                <td data-test-id="non-zero-event-placeholder-1">—</td>
              </tr>
              <tr>
                <td data-test-id="non-zero-event-placeholder-2">—</td>
              </tr>
            </>
          )}
        </tbody>
      </SummaryTable>
    </SummaryTile>
  );
};

export default ShortTermOperatingReservesSummaryTile;
